var map = {
	"./1.png": 6634,
	"./11.png": 5753,
	"./13.jpg.jpeg": 9681,
	"./1585.webp": 5012,
	"./2.png": 7217,
	"./2026-03-12_matratzen-1ru.png": 4353,
	"./22.png": 9655,
	"./2222luxurygoldentrianglelogo.png": 5354,
	"./2luxurygoldentriangle-logo.png": 8113,
	"./3.png": 9736,
	"./33.png": 4129,
	"./4.png": 8727,
	"./44.png": 3667,
	"./5.png": 3150,
	"./55.png": 4433,
	"./66.png": 6263,
	"./77.png": 9689,
	"./88.png": 6971,
	"./AboutUs.jpg.jpeg": 6756,
	"./Audi-Q7.jpeg": 2524,
	"./Ayurvedic-Body-Massage-India.jpg": 2542,
	"./BMW.jpg": 7437,
	"./Bold_Light-removebg-preview.png": 316,
	"./CSR-1.webp": 3053,
	"./Camel-Ride-Pushkar-India.jpg": 4381,
	"./Charlotte.png": 3155,
	"./Contactuspage1.jpeg": 3470,
	"./Contactuspage1.jpg": 1337,
	"./Contactuspage11.jpg": 6680,
	"./Cooking-Class-India.jpg": 4846,
	"./Cultural-Dance-Show-India.jpg": 5591,
	"./Delhi2.jpeg": 7660,
	"./Delhi3.jpeg": 4595,
	"./Delhi4.jpeg": 8594,
	"./Fairmont-Jaipur.jpg": 5147,
	"./Faydker.png": 8505,
	"./Forward.svg": 9298,
	"./Golden-Traingle-shortTour-India.jpg": 1354,
	"./Golden-Triangle-Oberoi.avif": 658,
	"./Golden-Triangle-Tiger-Tour.jpg": 7870,
	"./Golden-Triangle-Tour-Extensions.jpg.jpeg": 6919,
	"./Header4.webp": 9940,
	"./Henna-Tattoo-India.jpg": 573,
	"./Hilton-Jaipur-2.jpg": 3272,
	"./Hilton-Jaipur-21.jpg": 6591,
	"./Hilton-Jaipur-211.jpg": 2674,
	"./HomeAboutUs1.jpg": 2062,
	"./HomeAboutUs2.jpg": 5145,
	"./HomeAboutUs2.webp": 3807,
	"./Homestay-India.jpg": 347,
	"./Horse-Cart-Ride-India.jpg": 4768,
	"./ITC-Mughal-Agra.jpg": 4284,
	"./Imperial-Hotel-Delhi.jpg": 3384,
	"./India-Certified-Tour-Operator-768x270.png": 2107,
	"./India-Taj-Mahal-Luxury-Tour.jpg": 6391,
	"./Indian-Wedding.jpg": 9161,
	"./Innova-Crysta-Exterior-2.jpeg": 8684,
	"./Innova-Crysta-Exterior.jpg": 6678,
	"./Innova-Crysta-Interior-1-1.jpeg": 1685,
	"./Innova-Crysta-Interior-2-1.jpeg": 4844,
	"./Innova-Crysta-Interior-3-1.jpeg": 1119,
	"./Innova-Crysta-Interior.jpg": 4992,
	"./Kochi&Kerala.jpg": 231,
	"./Leela-Palace-hotel-Delhi.jpg": 4403,
	"./Luxury-Golden-Triangle-Flower.png": 6851,
	"./Luxury_Golden_Triangle_Tour_Logo-removebg-preview.png": 6048,
	"./MSME-transparent.png": 9592,
	"./MSME.jpeg": 9186,
	"./Market-Walking-Tour-India.jpg": 1252,
	"./Marriot-Hotel-Agra.jpg": 4352,
	"./Mercedes-1.jpg": 2101,
	"./Mercedes-E-Class.jpeg": 435,
	"./Mercedes-GLS.jpeg": 5985,
	"./Mercedes-V-Class.jpeg": 8906,
	"./Ministry-of-MicroSmall-Medium-Enterprises-transparent.png": 3638,
	"./Ministry-of-MicroSmall-Medium-Enterprises.jpeg": 2024,
	"./Oberoi-Amarvilas-1-small.jpg": 2358,
	"./Oberoi-Amarvilas-2-small.jpg": 2641,
	"./Oberoi-Amarvilas-3-small-1.jpg": 2906,
	"./Oberoi-Amarvilas-4-small.jpg": 551,
	"./Oberoi-Amarvilas-5-small-1.jpg": 6104,
	"./Oberoi-Amarvilas-Hotel-Agra.jpg": 3217,
	"./Oberoi-Hotel-Delhi-1-small.jpg": 4793,
	"./Oberoi-Hotel-Delhi-2-small.jpg": 1294,
	"./Oberoi-Hotel-Delhi-3-small.jpg": 4659,
	"./Oberoi-Hotel-Delhi-4-small.jpg": 4728,
	"./Oberoi-New-Delhi-1.jpg": 5775,
	"./Oberoi-Rajvilas-1-small.jpg": 7900,
	"./Oberoi-Rajvilas-2-small.jpg": 6899,
	"./Oberoi-Rajvilas-3-small.jpg": 142,
	"./Oberoi-Rajvilas-4-small-1.jpg": 5799,
	"./Oberoi-Rajvilas-5-small.jpg": 4424,
	"./Oberoi-Rajvilas-6.jpg": 9749,
	"./OberoiHotels.webp": 8012,
	"./Phone.svg": 2625,
	"./Rajat-1.jpeg": 5442,
	"./Rambagh-palace-jaipur.jpeg": 3471,
	"./Ranthambhore.jpeg": 5063,
	"./Ranthambhore.jpg": 6522,
	"./Ranthambhore1.jpg": 4629,
	"./Rawla_Narlai.webp": 98,
	"./Registration-No..png": 5254,
	"./Royal-Rajasthan-Escape.avif": 7083,
	"./Samode-Haveli.jpg": 8278,
	"./Sarovar-Hotel-Agra-1.jpg": 3928,
	"./Shagri-La-Delhi-1.jpg": 1486,
	"./ShortTour.webp": 3243,
	"./Slum-Tour-India.jpg": 6683,
	"./StandardTour.webp": 5854,
	"./Street-Food-India.jpg": 1723,
	"./Taj-Hotel-Agra-1.jpeg": 1720,
	"./Taj-Jai-Mahal.jpeg": 9280,
	"./Taj-Jai-Mahal11.jpeg": 8618,
	"./Taj-Mahal-Hotel-Delhi.jpeg": 4729,
	"./Taj-Mahal-Hotel-Delhi1.jpeg": 9152,
	"./Taj-Rambagh-Jaipur-1.jpg": 9637,
	"./Tempo-Traveler.jpeg": 5029,
	"./The-Taj-Palace-Delhi.jpg": 6282,
	"./Tiger2.webp": 1754,
	"./Toyota-Fortuner.jpeg": 5972,
	"./Toyota-Hiace.jpg": 1008,
	"./Traditional-music-Rajasthan.jpg": 4999,
	"./Trident-Agra.jpg": 3905,
	"./Trident-Jaipur-1.jpg": 2481,
	"./Udaipur-Sightseeing.jpeg": 7607,
	"./Udaipur.jpg": 3101,
	"./Unconfirmed 761277.crdownload": 7504,
	"./Unconfirmed 768887.crdownload": 6076,
	"./Urbania.webp": 5265,
	"./Urbania1.webp": 6908,
	"./Urbania2.webp": 6297,
	"./Van1.webp": 1509,
	"./Van3.webp": 9707,
	"./Vanluggagearea.webp": 4535,
	"./Varanasi-Boat-Ride-India.jpg": 3000,
	"./Varanasi-extension.jpg": 3800,
	"./Village-Tour-India.jpg": 4982,
	"./Volvo-Bus.jpg": 3728,
	"./WhatsApp Image 2026-03-26 at 21.56.43.jpeg": 5568,
	"./Yoga-Class-India.jpg": 8434,
	"./ab.webp": 7286,
	"./ab1.webp": 901,
	"./about1.webp": 9785,
	"./about2.webp": 5516,
	"./aboutus_tour.webp": 4109,
	"./amar.png": 3704,
	"./ankit.jpg": 8188,
	"./anna.png": 257,
	"./arrow-down.svg": 663,
	"./arrow-right-btn.svg": 6456,
	"./arrow-right.svg": 7095,
	"./auth1.webp": 2958,
	"./auth2.webp": 1599,
	"./auth3.webp": 1356,
	"./auth4.webp": 3933,
	"./auth5.webp": 8370,
	"./auth6.webp": 6019,
	"./auth7.webp": 5616,
	"./authentic.webp": 2932,
	"./backward.svg": 4824,
	"./beds.svg": 4699,
	"./best-luxury-private-india-tour.avif": 9734,
	"./bg-oo.webp": 1975,
	"./bgggg.jpeg": 4466,
	"./big.png": 3713,
	"./blog-big.webp": 7030,
	"./blog-im.webp": 5282,
	"./blog.webp": 1157,
	"./calender.svg": 981,
	"./cameljaipur.jpg": 7684,
	"./car-d.png": 4366,
	"./car-list.webp": 8404,
	"./car1.webp": 2584,
	"./car2.webp": 2341,
	"./car3.webp": 8074,
	"./card1.svg": 5146,
	"./card2.svg": 4441,
	"./card3.svg": 2072,
	"./card4.svg": 823,
	"./card5.svg": 7606,
	"./cardetial.jpeg": 7407,
	"./check.svg": 6729,
	"./clock.svg": 371,
	"./contact.webp": 7123,
	"./contactus.jpg": 5371,
	"./contactusimg.jpeg": 6599,
	"./dance-girl.svg": 527,
	"./dance-man.svg": 3907,
	"./delhiimage.jpg": 1226,
	"./elephant.svg": 6000,
	"./facebook.svg": 7103,
	"./favicon.png": 5963,
	"./festival-India.jpg": 6577,
	"./ff.webp": 1505,
	"./fff.webp": 9325,
	"./foot1-original-white.png": 3644,
	"./foot1.png": 5574,
	"./foot2-original-white.png": 2289,
	"./foot2.png": 7197,
	"./frc.webp": 3162,
	"./frg.webp": 7910,
	"./gfr.webp": 9586,
	"./girsih.jpg": 8781,
	"./golden-triangle-tiger-tour.avif": 7376,
	"./golden-triangle-tour-extensions.jpg": 6849,
	"./goldentrianglestandardtour.jpg": 6845,
	"./google-plus.svg": 575,
	"./h1.webp": 3374,
	"./h2.webp": 9471,
	"./h3.webp": 2380,
	"./h4.webp": 3453,
	"./h5.webp": 7042,
	"./image 1.svg": 3419,
	"./image 2.svg": 2056,
	"./india-map.jpg": 5663,
	"./insta-bf.webp": 9995,
	"./insta-head.svg": 5163,
	"./insta-icon.svg": 7110,
	"./instagram.svg": 6149,
	"./inverted-comma.svg": 6654,
	"./jaipurimg.avif": 4331,
	"./jens.png": 4989,
	"./katerina.png": 8066,
	"./landingcom.jpg": 7187,
	"./landingimage.jpg": 4371,
	"./leela-palace-jaipur.jpeg": 7536,
	"./linkdin.svg": 5512,
	"./lndingimage.jpeg": 4279,
	"./loca.png": 2156,
	"./logo.svg": 3914,
	"./luxurygoldentriangle-favicon.png": 4308,
	"./luxurygoldentrianglelogo.png": 4722,
	"./luxurylogo.png": 57,
	"./maidens-hotel-logo-transparent.png": 4220,
	"./mail.svg": 2558,
	"./map-marker.svg": 8622,
	"./map_marker.svg": 7444,
	"./mapp.png": 9357,
	"./maria.png": 7537,
	"./oberoihotel.jpg": 4299,
	"./oberoihotel_banner.jpg": 9474,
	"./oberoihotelbanner.webp": 925,
	"./oberoihotels.avif": 8898,
	"./obroiehotel.jpg": 5509,
	"./ol.webp": 1114,
	"./part1.png": 2215,
	"./part1.webp": 9791,
	"./part10.png": 6887,
	"./part10.webp": 4857,
	"./part11.png": 1310,
	"./part11.webp": 7070,
	"./part2.png": 3484,
	"./part2.webp": 6542,
	"./part3.png": 997,
	"./part3.webp": 1225,
	"./part4.png": 6330,
	"./part4.webp": 208,
	"./part5.png": 7091,
	"./part5.webp": 3251,
	"./part6.png": 2600,
	"./part6.webp": 8354,
	"./part7.png": 5313,
	"./part7.webp": 269,
	"./part8.png": 5510,
	"./part8.webp": 4804,
	"./part9.png": 4255,
	"./part9.webp": 8983,
	"./partner1.svg": 2564,
	"./peacock.svg": 1523,
	"./pexels-amol-nakve-2148578663-30259519.jpg": 4250,
	"./pexels-mursel-200615173-36405801.jpg": 6665,
	"./pexels-wanderinglenses-25399661.jpg.jpeg": 6852,
	"./phone-call.svg": 2426,
	"./profile.png": 5572,
	"./r1.webp": 3756,
	"./raj.webp": 4902,
	"./rambagpalace.avif": 165,
	"./re.webp": 288,
	"./return-delhi.jpg": 7940,
	"./rev.webp": 6726,
	"./reviewbigimg.jpeg": 325,
	"./rff.webp": 25,
	"./royalrajasthan.avif": 8068,
	"./secondlogo.png": 2482,
	"./serb.webp": 3025,
	"./slide2.jpg": 912,
	"./slide3.jpg": 5485,
	"./slider1.webp": 295,
	"./slider2.webp": 1046,
	"./slider3.webp": 5777,
	"./small.png": 5222,
	"./star-s.png": 2599,
	"./support-banner.jpeg": 8648,
	"./tailor_mad_tour.jpeg": 2841,
	"./tailormadetour.webp": 8697,
	"./taj-mahal.svg": 3878,
	"./tajlogo-removebg-preview.png": 2996,
	"./tajlogo.png": 3683,
	"./term&condition.jpg": 7348,
	"./theimperial.avif": 375,
	"./thmoas.png": 9447,
	"./tiger.svg": 3372,
	"./tours.jpeg": 5443,
	"./twitter.svg": 6072,
	"./whatsapp-sm.svg": 7353,
	"./whatsapp.svg": 3465,
	"./yg.png": 1831,
	"./youtube.svg": 6046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7106;